import React from 'react';
import { steps } from '../data/site';
export function HowIWork() {
  return <section id="how-i-work" className="bg-paper-soft border-b border-rule" data-id="element-74" data-mp="g4dwqvjdbzqm">
      <div className="max-w-content mx-auto px-6 lg:px-10 py-20 md:py-24" data-id="element-75" data-mp="g6guy2uocz6f">
        <h2 className="font-serif text-3xl md:text-4xl leading-tight tracking-tight text-ink max-w-3xl" data-id="element-76" data-mp="b5t35eymgeb5">
          Understand the problem. Lead the change. Make it last.
        </h2>

        <ol className="mt-12 md:mt-14 grid md:grid-cols-3 gap-10 md:gap-8" data-id="element-77" data-mp="13sx4n9yiaai6">
          {steps.map(step => <li key={step.number} className="flex flex-col md:pr-6" data-id="element-78" data-mp="yvf3i5qqczkq">
              <div className="flex items-center gap-4" data-id="element-79" data-mp="u3djfxnbm4k5">
                <span className="font-serif text-2xl text-clay" data-id="element-80" data-mp="u1snq4p9sfkp">{step.number}</span>
                <span aria-hidden="true" className="h-px flex-1 bg-rule" data-id="element-81" data-mp="q2bj1dho3mgl" />
              </div>
              <h3 className="mt-5 font-serif text-xl md:text-[1.375rem] leading-snug text-ink" data-id="element-82" data-mp="1mlr7j5iuuc61">
                {step.title}
              </h3>
              <p className="mt-4 text-base leading-relaxed text-ink-soft" data-id="element-83" data-mp="2yx80vxcdgswd">{step.body}</p>
            </li>)}
        </ol>

        <div className="mt-14 md:mt-16 bg-ink text-paper rounded-lg p-8 md:p-10" data-id="element-84" data-mp="33uzpoihpzywc">
          <div className="md:flex md:items-start md:gap-12" data-id="element-85" data-mp="2p7ws6btedq90">
            <h3 className="font-serif text-xl md:text-[1.375rem] leading-snug md:w-1/3 shrink-0" data-id="element-86" data-mp="2p5ak8b2lh8q9">
              Focused support for a defined period
            </h3>
            <p className="mt-4 md:mt-0 text-base leading-relaxed text-paper-deep md:w-2/3" data-id="element-87" data-mp="2g4vmgc8g215v">
              Most engagements run 2–6 months, typically 10–25 hours per week. We agree
              on the outcomes, scope, and working rhythm at the outset, then adjust as we learn. I
              take on a limited number of engagements so I can stay closely involved.
            </p>
          </div>
        </div>
      </div>
    </section>;
}